<div #scanner id="scanner" [hidden]="!isStarted">
    <video id="video" width="300" height="200"></video>
    <canvas class="drawingBuffer"></canvas>
</div>
